import InfoIcon from '@mui/icons-material/Info';
import { Tooltip } from '@mui/material';
import type React from 'react';
import styled from 'styled-components';

export type InfoTooltipProps = {
  readonly text: string;
  readonly top?: boolean;
  readonly bottom?: boolean;
};

const TooltipIcon = styled(InfoIcon)`
  color: ${({ theme }) => theme.palette.grey['500']};
  height: 1.3rem;
  width: 1.3rem;
  vertical-align: middle !important;
`;

/** Renders an info icon and help text when hovering. */
export const InfoTooltip: React.FC<InfoTooltipProps> = (props) => {
  const { text, top, bottom } = props;
  const placement = top ? 'top' : bottom ? 'bottom' : undefined;
  return (
    <Tooltip arrow title={text} placement={placement}>
      <TooltipIcon />
    </Tooltip>
  );
};

export default InfoTooltip;
